<template>
  <span
    v-if="icon"
    :class="classList"
    :style="styleList"
    class="c-icon inline-flex justify-center items-center rounded-lg transition"
  />
</template>

<script>
import { props } from './props'
import { computed } from 'vue'

export default {
  name: 'CIcon',
  props,
  setup (props) {
    const isImage = computed(() => props.icon?.match(/^(http[s]:\/\/|\/)/))

    const classList = computed(() => {
      return {
        'status-turn': props.turn,
        'status-disabled': props.disabled,
        [`icon-${props.icon}`]: props.icon && !isImage.value,
        [`color-${props.color}`]: props.color,
        [`size-${props.size}`]: props.size,
        'option-image': isImage.value,
        'option-background': props.background
      }
    })
    const styleList = computed(() => {
      return { '--ic-image': isImage.value ? `url(${props.icon})` : null }
    })

    return {
      classList,
      styleList
    }
  }
}
</script>

<style lang="scss">
@import "style";
</style>
